/**
 * AlphaSense Agent - System Prompt Builder
 *
 * Assembles the 5-section system prompt for the AlphaSense research agent.
 * Uses Keywords AI prompts if available, with code fallbacks.
 */
import { SystemPromptBuilder } from '../../../base/systemPrompt';
import { getIntroSection, ALPHASENSE_INTRO } from './intro';
import { buildToolsSection } from './tools';
import { getSuggestionsSection, ALPHASENSE_SUGGESTIONS } from './suggestions';
import { getContextNoteSection, ALPHASENSE_CONTEXT_NOTE } from './contextNote';
import { getEvaluationSection, ALPHASENSE_EVALUATION } from './evaluation';
/**
 * Build the complete system prompt for the AlphaSense agent.
 * Uses Keywords AI prompts if available, with code fallbacks.
 */
export function buildAlphaSenseSystemPrompt(params = {}) {
    const hasContext = params.resolvedContext && params.resolvedContext.length > 0;
    const builder = new SystemPromptBuilder();
    let prompt = builder.build({
        intro: getIntroSection(),
        tools: buildToolsSection(params.tools || []),
        suggestions: getSuggestionsSection(),
        contextNote: getContextNoteSection(hasContext),
        evaluation: getEvaluationSection(),
    });
    // Append resolved context if available
    if (hasContext && params.resolvedContext) {
        const contextDescriptions = params.resolvedContext.map(item => {
            const ids = Array.from(item.resolved.keys()).join(', ');
            return `- ${item.original.purpose} (IDs: ${ids})`;
        }).join('\n');
        prompt += `\n\n## Available Context\n${contextDescriptions}`;
    }
    return prompt;
}
// Export all sections for admin panel access
export { getIntroSection, buildToolsSection, getSuggestionsSection, getContextNoteSection, getEvaluationSection, ALPHASENSE_INTRO, ALPHASENSE_SUGGESTIONS, ALPHASENSE_CONTEXT_NOTE, ALPHASENSE_EVALUATION, };
// Variables and prompt configuration
export { ALPHASENSE_VARIABLES, ALPHASENSE_PROMPT_KEYS, ALPHASENSE_PROMPT_CONFIG, } from './variables';
